<div class="row w-100 d-flex p-0 align-items-center item-row dashboard">

    <!-- Header - Bijgewerkt (en selectie checkbox) -->
    <div class="col-md-2 col-lg-2 col-xl col-xxl d-none d-md-block ps-md-4 ps-lg-4 ps-xl-2 ps-xxl-2 text-truncate">
        <input type="checkbox"
            class="ms-3 mt-1 d-none d-xl-inline-block form-check-input checkbox dashboard activityItem" name="item"
            id="item" value="" (click)="$event.stopPropagation();" (change)="$event ? selection.toggle(request) : null"
            [checked]="selection.isSelected(request)">
        <span>{{getLastUpdated() | date:'dd-MM-yy HH:mm' }}</span>
    </div>

    <!-- Header - Verzoek (status en navigatie ) -->
    <div class="col-8 col-sm-8 col-md-4 col-lg-4 text-truncate ps-4 ps-sm-4 ps-md-2 ps-lg-2 ps-xl-2 s-xxl-2 cursor-pointer"
        [ngClass]="{'col-xl-3 col-xxl-2': workgroup, 'col-xl-4 col-xxl-3': !workgroup, 'opacity-50': displayAsInactive }"
        (click)="clickOnRequest()">
        <app-status-display [status]="request.status" [displayStatusString]="false"
            [displayStatusOrb]="true"></app-status-display>
        <div class="request-name">
            {{getRequestNameText()}}
        </div>
    </div>

    <!-- Header - Type (verzoek type) -->
    <div class="col-xl col-xxl d-none d-xl-block text-truncate activityItem">
        <span>{{getRequestTypeText()}}</span>
    </div>

    <!-- Header - Actie uitgevoerd -->
    <div class="col-xl col-xxl d-none text-truncate activityItem"
        [ngClass]="{'d-xl-block': !workgroup, 'd-xxl-block': workgroup }">
        <span>{{getRequestPreviousActionText()}}</span>
    </div>

    <!-- Header - Door -->
    <div class="col-xxl d-none d-xxl-block col text-truncate activityItem">
        <span>{{getByText()}}</span>
    </div>

    <!-- Header - Fase -->
    <div class="col-md-2 col-lg-2 col-xl col-xxl d-none d-md-block text-truncate activityItem">
        <span>{{getRequestStageText()}}</span>
    </div>

    <!-- Header - Deadline -->
    <div class="col-4 col-sm-4 col-md-2 col-lg-2 col-xl col-xxl text-truncate activityItem">
        <span> {{getDeadlineDate() | date:'dd-MM-yy HH:mm'}}</span>
    </div>

    <!-- Header - Werkgroep -->
    <div class="col-xl col-xxl d-none d-xl-block text-truncate activityItem"
        *ngIf="workgroup && (anyWorkgroup || showAll)">
        <span> {{getWorkgroupText()}}</span>
    </div>

    <!-- Header - Eigenaar -->
    <div class="col-xl col-xxl d-none d-xl-block text-truncate activityItem"
        *ngIf="workgroup && (anyWorkgroup || showAll)">
        <span> {{getOwnerText()}}</span>
    </div>
</div>

<!-- extra row just to align the 'Ga naar verzoek' Button -->
<div class="row w-100 d-flex p-0 align-items-center item-row dashboard ms-md-3" *ngIf="displayGoToRequestButton">
    <div class="col-md-2 col-lg-2 col-xl col-xxl d-none d-md-block ps-md-4 ps-lg-4 ps-xl-2 ps-xxl-2 text-truncate">
    </div>
    <div class="ms-3 col-8 col-sm-8 col-md-4 col-lg-4 text-truncate ps-4 ps-sm-4 ps-md-2 ps-lg-2 ps-xl-2 s-xxl-2"
        [ngClass]="{'col-xl-3 col-xxl-2': workgroup, 'col-xl-4 col-xxl-3': !workgroup, 'opacity-50': displayAsInactive }">
        <div class="mb-2 ms-md-2">
            <button type="button" class="btn btn-sm btn-success cursor-pointer"
                (click)="goToSentRequest(request.requestId, request.status, request.workflowId)"
                translate>Button.GoToDocument</button>
        </div>
    </div>
    <div class="col-xl col-xxl d-none d-xl-block text-truncate"></div>
    <div class="col-xl col-xxl d-none text-truncate" [ngClass]="{'d-xl-block': !workgroup, 'd-xxl-block': workgroup }">
    </div>
    <div class="col-xxl d-none d-xxl-block col text-truncate"></div>
    <div class="col-md-2 col-lg-2 col-xl col-xxl d-none d-md-block text-truncate"></div>
    <div
        class="col-md-2 col-lg-2 col-xl col-xxl d-xs-none d-sm-none d-md-block d-lg-block d-xl-none d-xxl-block text-truncate">
    </div>
    <div class="col-xs-4 col-sm-4 col-md-2 col-lg-2 col-xl col-xxl text-truncate"></div>
    <div class="col-xl col-xxl d-none d-xl-block text-truncate" *ngIf="workgroup && anyWorkgroup"></div>
    <div class="col-xl col-xxl d-none d-xl-block text-truncate" *ngIf="workgroup && anyWorkgroup"></div>
</div>